document.addEventListener('DOMContentLoaded', function () {
    var loginRequiredBtn = document.querySelector('.enroll-card__btn.login-required');
    var loginPopupOverlay = document.getElementById('loginRequiredPopupOverlay');
    var loginCloseBtn = document.getElementById('loginRequiredPopupClose');

    // Show Login Required Popup
    if (loginRequiredBtn && loginPopupOverlay) {
        loginRequiredBtn.addEventListener('click', function (e) {
            e.preventDefault();
            loginPopupOverlay.classList.add('active');
            document.body.style.overflow = 'hidden';
        });
    }

    // Close button
    if (loginCloseBtn && loginPopupOverlay) {
        loginCloseBtn.addEventListener('click', function () {
            loginPopupOverlay.classList.remove('active');
            document.body.style.overflow = '';
        });
    }

    // Click outside to close
    window.addEventListener('click', function (e) {
        if (e.target === loginPopupOverlay) {
            loginPopupOverlay.classList.remove('active');
            document.body.style.overflow = '';
        }
    });
});
